import { DiaryEntryFormValues } from './components/AddDiaryEntryModal';

/**
 * Attachment names the backend will actually receive for these files, derived
 * from the SAME source `buildDiaryFormData` sends (`file.originFileObj`, whose
 * `.name` becomes the stored `original_filename`). Kept next to the FormData
 * builder so the email preview lists exactly the attachments a real submit would
 * include — same files (only those with an `originFileObj`) and same names — and
 * the two can't drift. `file.name` is only a last-resort fallback.
 */
export const diaryAttachmentNames = (values: DiaryEntryFormValues): string[] => (
    (values.files ?? [])
        .filter((file) => file.originFileObj)
        .map((file) => (file.originFileObj?.name ?? file.name ?? '').trim())
        .filter((name) => name.length > 0)
);

const buildDiaryFormData = (values: DiaryEntryFormValues): FormData => {
    const formData = new FormData();
    formData.append('text', values.text);
    if (values.entryOccurredAt) {
        formData.append('entry_occurred_at', values.entryOccurredAt);
    }
    formData.append(
        'sent_to_distribution',
        values.sentToDistribution ? '1' : '0',
    );
    if (values.files?.length) {
        values.files.forEach((file) => {
            if (file.originFileObj) {
                formData.append('files[]', file.originFileObj);
            }
        });
    }
    return formData;
};

export default buildDiaryFormData;
